import(/* webpackMode: "eager" */ "/app/apps/consumer/app/(public)/page.tsx");
